import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractConcessions(sale: Element): string | undefined {
  return extractAdjustmentDescription(sale, 'FinancingConcessions');
}
